export const EF_THEME_COLORS: Record<string, string> = {
  'task initiation':      'bg-blue-100 text-blue-800',
  'working memory':       'bg-purple-100 text-purple-800',
  'time management':      'bg-green-100 text-green-800',
  'emotional regulation': 'bg-yellow-100 text-yellow-800',
  organization:           'bg-orange-100 text-orange-800',
  prioritization:         'bg-red-100 text-red-800',
  'sustained attention':  'bg-indigo-100 text-indigo-800',
  'cognitive flexibility':'bg-pink-100 text-pink-800',
};

export type BadgeVariant = 'green' | 'blue' | 'yellow' | 'red' | 'gray';

export const APPOINTMENT_STATUS_COLORS: Record<string, BadgeVariant> = {
  completed:  'green',
  scheduled:  'blue',
  confirmed:  'blue',
  in_progress:'blue',
  cancelled:  'gray',
  no_show:    'gray',
};

export const CLIENT_STATUS_COLORS: Record<string, BadgeVariant> = {
  active:   'green',
  inactive: 'gray',
  new:      'blue',
};

export const DOCUMENT_STATUS_COLORS: Record<string, BadgeVariant> = {
  signed:  'green',
  pending: 'yellow',
  sent:    'blue',
  expired: 'red',
};
